import { DEFAULT_CHOPPER_DOMAIN } from '@community_dev/hooks'

import { hasConfiguredCustomDomain } from '../CustomDomain/utils'

import { useClientSettings } from './useClientSettings'

export const useChopperDomain = (clientId: string, whiteLabelEnabled: boolean): string => {
  const { settings } = useClientSettings(clientId)
  const customDomain = settings?.customDomain

  return whiteLabelEnabled && hasConfiguredCustomDomain(customDomain)
    ? `${customDomain.domain}/m`
    : DEFAULT_CHOPPER_DOMAIN
}
